var map = {
	"./black.svg": "./src/assets/svg/chips/black.svg",
	"./blue.svg": "./src/assets/svg/chips/blue.svg",
	"./orange.svg": "./src/assets/svg/chips/orange.svg",
	"./purple.svg": "./src/assets/svg/chips/purple.svg",
	"./yellow.svg": "./src/assets/svg/chips/yellow.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/svg/chips sync recursive ^\\.\\/.*\\.svg$";